import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import HeaderBread from "../../../components/HeaderBread";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import Layout from "../../../Layout";

import { message } from "antd";
import Swal from "sweetalert2";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import CustomizedDragNDrop from "../../../components/UI/CustomizedDragNDrop";
import DeletePop from "../../../constants/ErrorPermissionModal";
import {
  deleteCrisisData,
  getCrisisData,
  updateCrisisData,
  updatePosition,
} from "../../../utils/ApiCalls/CrisisData";

import Vessel from "../../../components/UI/VesselFilter";
import { addlog } from "../../../utils/ApiCalls/Logs";
import Logs from "../../../components/Logs";
import SwitchBar from "../../../components/Pages/SwitchBar";
import { getVessels } from "../../../utils/ApiCalls/SpecialPage";
import { checkPermission } from "../../../utils/Validation/checkPermission";
import { LOG_ACTIONS } from "../../../utils/Constant/LogConstant";

const CrisisData = () => {
  const navigate = useNavigate();
  const [active, setActive] = useState("listing");
  const [vesselOptions, setVesselOptions] = useState([]);
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "Crisis Data",
      route: "/website/cms/crisis-page/Crisis-data",
    },
  ];
  const [rows, setRows] = useState([]);
  const [count, setCount] = useState(0);
  const [{ userDetails, permission }, dispatch] = useDataLayerValue();
  const [columns, setColumns] = useState([]);
  const [sort, setSort] = useState("");
  const [order, setOrder] = useState("");
  const [vesselId, setVesselId] = useState();

  const locationP = useLocation();

  const [page, setPage] = useState(
    () => parseInt(new URLSearchParams(locationP.search).get("page")) || 1
  );
  const [pageSize, setPageSize] = useState(
    () => parseInt(new URLSearchParams(locationP.search).get("pageSize")) || 10
  );
  const [search, setSearch] = useState(
    () => new URLSearchParams(locationP.search).get("search") || ""
  );

  useEffect(() => {
    const params = new URLSearchParams(locationP.search);
    const pageParam = parseInt(params.get("page")) || 1;
    const pageSizeParam = parseInt(params.get("pageSize")) || 10;
    const searchParam = params.get("search") || "";

    // setPage(pageParam);
    // setPageSize(pageSizeParam);
    setSearch(searchParam);
  }, [locationP.search]);

  useEffect(() => {
    const params = new URLSearchParams();
    const currentParams = new URLSearchParams(locationP.search);

    params.set("page", page);
    params.set("pageSize", pageSize);
    if (search) params.set("search", search);

    if (currentParams.toString() !== params.toString()) {
      navigate({ search: params.toString() }, { replace: true });
    }
  }, [page, pageSize, search, navigate, locationP.search]);


  const sortHandler = async (options) => {
    if (Object.keys(options).length > 0) {
      let sort, order;
      sort = options.columnKey;
      order =
        options.order === "ascend"
          ? "asc"
          : options.order === "descend"
          ? "desc"
          : undefined;
      setSort(sort);
      setOrder(order);
      await getData(page, sort, order);
    }
  };
  const setPositionalValue = (data) => {};

  const updateBannerPosition = async (banners) => {
    if (checkPermission(permission, "update_per", "Crisis Data",window?.location?.pathname)) {
      try {
        let args = { search: search, page: page, limit: pageSize };

        const data = await updatePosition(banners, args);
        addlog(
          "Crisis Data Position Updated",
          "Crisis Data",
          { location_id: banners[0].id },
          userDetails.id
        );
        if (data.error) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: data.error,
          });
        } else if (data.data) {
          setRows(data.data);
          setCount(data.count);
          setPositionalValue(data.data);
        }
        dispatch({
          type: "SET_LOADING",
          loading: false,
        });
      } catch (error) {
        dispatch({
          type: "SET_LOADING",
          loading: false,
        });

        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.message || "Unknown error occurred",
        });
      }
    } else {
      message.error("Update permission missing");
    }
  };
  useEffect(() => {
    setColumns([
      {
        title: "Sl",
        width: 10,
        dataIndex: "id",
        key: "id",
        fixed: "left",
        render: (position, record, index) => (page - 1) * pageSize + index + 1,
      },
      {
        title: "Title",
        dataIndex: "title",
        key: "title",
        width: 400,
        render: (item) => <div dangerouslySetInnerHTML={{ __html: item }} />,
      },
      {
        title: "Vessel",
        dataIndex: "vessel_id",
        key: "vessel_id",
        width: 400,
        render: (val) => (
          <div>{vesselOptions.find((item) => item.id == val)?.name}</div>
        ),
      },

      {
        title: "Action",
        key: "operation",
        width: 100,
        render: (text, record) => (
          <div className="table_action_btn">
            <button className="btn" onClick={() => handleEdit(record.id)}>
              <i
                className="ri-edit-2-line"
                data-toggle="tooltip"
                title="Edit"
              ></i>
            </button>
            <DeletePop onConfirm={() => handleDelete(record.id)}>
              <div>
                {" "}
                <button className="btn delete_btn">
                  <i
                    className="ri-delete-bin-line"
                    data-toggle="tooltip"
                    title="Delete"
                  ></i>
                </button>
              </div>
            </DeletePop>
          </div>
        ),
      },
    ]);
  }, [page, pageSize, vesselOptions]);
  useEffect(() => {
    getData(page);
  }, [page, pageSize]);

  const handleUpdate = async (id, values, title, location_id) => {
    if (checkPermission(permission, "update_per", "Crisis data",window?.location?.pathname)) {
      let data = await updateCrisisData(id, values);
      if (data.error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: data.error,
        });
      } else {
        addlog(
          "Crisis data " +
            (!values.valid_from
              ? values.is_active === 1
                ? LOG_ACTIONS.ACTIVATED
                : LOG_ACTIONS.DEACTIVATED
              : LOG_ACTIONS.UPDATED),
          "Crisis data",
          { ...values, id, title, location_id },
          userDetails.id
        );
      }
      getData(page);
    } else {
      message.error("Update permission missing");
    }
  };
  useEffect(() => {
    getOptionLocation();
  }, []);

  const getOptionLocation = async () => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });

    let vessels = await getVessels();
    if (vessels.error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: vessels.error,
      });
    } else {
      setVesselOptions(vessels);
    }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  const getData = async (value) => {
    let data = await getCrisisData({
      page: value,
      limit: pageSize,
      vessel_id: vesselId,
    });
    if (data.error)
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data.error, type: "error" },
      });
    else if (data.data) {
      setRows(data.data);
      setCount(data.count);
    }
  };
  const handleEdit = async (id) => {
    if (checkPermission(permission, "update_per", "Crisis Data",window?.location?.pathname)) {
      navigate("/website/cms/crisis-page/Crisis-data/edit/" + id);
    } else {
      message.error("Update permission missing");
    }
  };
  const handleDelete = async (id) => {
    if (checkPermission(permission, "delete_per", "Crisis data",window?.location?.pathname)) {
      await deleteCrisisData(id);
      addlog("Crisis Data Deleted", "Crisis Data", { id }, userDetails.id);
      getData();
    } else {
      message.error("Missing Permission for delete");
    }
  };

  return (
    <Layout type={"read_per"} module_data={"Crisis data"}>
      <CustomHeaderTitle title={"Crisis data"} />
      <div>
        <div>
          <HeaderBread
            navigation={navigation}
            title={"Crisis data"}
          ></HeaderBread>
        </div>
        <section className="content" style={{ marginTop: "20px" }}>
          <div className="container-fluid">
            <SwitchBar
              tabs={[
                { title: "Crisis Data List", value: "listing" },
                { title: "History Logs", value: "logs" },
              ]}
              activeTab={active}
              setActiveTab={setActive}
            />
            {active === "listing" && (
              <div className="card">
                <div className="card-header two_item">
                  <h5 className="card-title">Crisis data List</h5>
                  <div className="two_item">
                    <Vessel
                      setVesselId={setVesselId}
                      vesselData={vesselOptions}
                      vesselId={vesselId}
                      getData={getData}
                      setPage={setPage}
                      width={150}
                    />
                    <Link
                      to="/website/cms/crisis-page/Crisis-data/add"
                      className="btn add_v_btn mx-2"
                    >
                      Add Crisis data
                    </Link>
                  </div>
                </div>
                <div className="card-body">
                  <div className="table_holder">
                    {rows && columns && (
                      <CustomizedDragNDrop
                        setRows={setRows}
                        setPageSize={setPageSize}
                        setPage={setPage}
                        pageSize={pageSize}
                        page={page}
                        count={count}
                        columns={columns}
                        rows={rows}
                        title={"Crisis Page"}
                        sortHandler={sortHandler}
                        updatePosition={updateBannerPosition}
                      />
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>
        {active === "logs" && <Logs type={"Crisis Data"} />}
      </div>
    </Layout>
  );
};

export default CrisisData;
